import styled from '@emotion/styled';
import { BreakPointToken } from '../../hooks/useMediaQuery';
export const DatePickerField = styled.div``;

export const FooterContent = styled.div`
	@media (min-width: ${BreakPointToken.MdMin}px) {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
`;
export const Alert = styled.p`
	display: flex;
	align-items: flex-start;
	color: var(--token-color-colour-text-error);
	font-size: 12px;
	margin-top: 4px;
`;

export const AlertMessage = styled.span`
	margin-left: 4px;
`;
